import { Box } from '@mui/material'
import styled from '@emotion/styled'
import { colors, typography } from '@resiliatech/birdsong'

export const LoadingImpactPlanContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 32px;
  width: 100%;
`

export const LoadingHeader = styled.h3`
  ${typography.up3.regularSans}
  color: ${colors.primary.main};
  margin: 0;
  text-transform: uppercase;
`

export const WandWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 180px;
  margin: 8px;
`

export const WandCircle = styled.div`
  background-color: ${colors.secondary.dark};
  border-radius: 50px;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  border: 1px solid #004f9e;
`

export const PulsingCircle = styled.div`
  position: absolute;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  background-color: ${colors.feedback.infoLight};
  z-index: 0;

  @keyframes pulse {
    0% {
      transform: scale(0.95);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(0.95);
    }
  }

  animation: pulse 1s infinite;
`

export const Description = styled.p`
  ${typography.baseline.regularSans};
  color: ${colors.copy.paragraphDark};
  text-align: center;
  margin: 0;
`
